import React from 'react';
import { Link } from 'react-router-dom';
import { categoryPath } from '../../../services/storefront';
import { IconArrowRight, Longhorn } from '../../storefront/icons';

const GRANDCHILD_PREVIEW = 6;

// Full-width panel under the header: every top-level collection on the left,
// the hovered collection's categories in the middle, its image on the right.
const MegaMenu = ({ id, open, roots, activeRootId, onActivate, onPointerEnter }) => {
  const active = roots.find((root) => root.id === activeRootId) || roots[0];

  return (
    <div
      id={id}
      className={`tp-mega${open ? ' is-open' : ''}`}
      onMouseEnter={onPointerEnter}
      inert={!open}
    >
      <div className="tp-mega__inner tp-container">
        <div className="tp-mega__rail">
          <p className="tp-mega__label">
            Collections <span>{roots.length}</span>
          </p>
          <ul className="tp-mega__roots">
            {roots.map((root) => (
              <li key={root.id}>
                <Link
                  to={categoryPath(root.id)}
                  className={`tp-mega__root${root.id === active?.id ? ' is-active' : ''}`}
                  onMouseEnter={() => onActivate(root.id)}
                  onFocus={() => onActivate(root.id)}
                >
                  <span>{root.name}</span>
                  {root.children.length > 0 && (
                    <span className="tp-mega__count">{root.children.length}</span>
                  )}
                </Link>
              </li>
            ))}
          </ul>
          <Link to="/products" className="tp-textlink tp-mega__all">
            Shop all products <IconArrowRight size={16} />
          </Link>
        </div>

        {active && (
          <div className="tp-mega__panel" key={active.id}>
            <div className="tp-mega__panel-head">
              <h2 className="tp-mega__title">{active.name}</h2>
              <Link to={categoryPath(active.id)} className="tp-textlink">
                Shop all <IconArrowRight size={16} />
              </Link>
            </div>

            {active.children.length > 0 ? (
              <ul className="tp-mega__children">
                {active.children.map((child) => (
                  <li key={child.id}>
                    <Link to={categoryPath(child.id)} className="tp-mega__child">
                      {child.name}
                    </Link>
                    {child.children.length > 0 && (
                      <p className="tp-mega__grandchildren">
                        {child.children.slice(0, GRANDCHILD_PREVIEW).map((grandchild, i) => (
                          <React.Fragment key={grandchild.id}>
                            {i > 0 && ', '}
                            <Link to={categoryPath(grandchild.id)}>{grandchild.name}</Link>
                          </React.Fragment>
                        ))}
                        {child.children.length > GRANDCHILD_PREVIEW && (
                          <>
                            {' '}
                            <Link to={categoryPath(child.id)} className="tp-mega__more">
                              +{child.children.length - GRANDCHILD_PREVIEW} more
                            </Link>
                          </>
                        )}
                      </p>
                    )}
                  </li>
                ))}
              </ul>
            ) : (
              <p className="tp-mega__empty">
                One collection, no sub-categories — browse everything in {active.name}.
              </p>
            )}
          </div>
        )}

        {active && (
          <Link to={categoryPath(active.id)} className="tp-mega__feature" key={`feature-${active.id}`}>
            <span className="tp-mega__feature-media">
              {active.image_url ? (
                <img src={active.image_url} alt="" loading="lazy" decoding="async" />
              ) : (
                <Longhorn className="tp-mega__feature-glyph" />
              )}
            </span>
            <span className="tp-mega__feature-caption">
              <span className="tp-mega__feature-kicker">Explore the collection</span>
              <span className="tp-mega__feature-name">{active.name}</span>
            </span>
            <span className="tp-mega__feature-go" aria-hidden="true">
              <IconArrowRight size={18} />
            </span>
          </Link>
        )}
      </div>
    </div>
  );
};

export default MegaMenu;
